// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"318b7091","104":"407db530","161":"8d4b74c5","215":"985a7c00","651":"1dfb7895","679":"a7bb3bf7","780":"8127478e"}[chunkId] + ".chunk.js";
};